<template>
  <div class="pa-16">
    <v-progress-linear indeterminate rounded />
    <h5 class="text-center grey--text pt-3 mb-0">
      {{ $t('appointment.table.loading') }}
    </h5>
  </div>
</template>

<script>
export default {
  name: 'Loading',
}
</script>
